/**
 * Various utilities/helpers for array objects, defined directly on the Array prototype
 * (i.e., polyfills)
 * @category array
 * @remarks
 * It is likely that most of those polyfills are useless now that we are targeting ES2017
 * They should probably be reviewed, checked during start.js, and removed from here
 * Also, the error messages are in French because most polyfills were copied from the French MDN site
 */

if (!Array.prototype.find) {

    Array.prototype.find = function (predicate) {

        if (this == null) {
            throw new TypeError('Array.prototype.find a été appelé sur null ou undefined');
        }

        if (typeof predicate !== 'function') {
            throw new TypeError('predicate doit être une fonction');
        }

        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return value;
            }
        }

        return undefined;
    };

}


if (!Array.prototype.remove) {

    Array.prototype.remove = function (predicate) {

        if (this == null) {
            throw new TypeError('Array.prototype.remove a été appelé sur null ou undefined');
        }

        var item = this.find(predicate);
        if (item === undefined) {
            return false;
        }

        var index = this.indexOf(item);
        if (index >= 0) this.splice(index, 1);
        return true;

    }

}


if (!Array.prototype.removeAll) {

    Array.prototype.removeAll = function (predicate) {

        if (this == null) {
            throw new TypeError('Array.prototype.removeAll a été appelé sur null ou undefined');
        }

        while (true) {

            var item = this.find(predicate);
            if (item === undefined) {
                break;;
            }

            var index = this.indexOf(item);
            if (index >= 0) this.splice(index, 1);

        }

    }

}

if (!Array.prototype.unique) {

    Array.prototype.unique = function (keySelector) {

        if (this.length <= 1) {
            return this
        }

        const seen = new Set()

        return this.filter(item => {
            const key = keySelector(item);
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);
            return true;
        });

    }

}

